var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-data-table',{attrs:{"items":_vm.items,"headers":_vm.headers,"server-items-length":_vm.count,"options":_vm.pagination,"loading":_vm.loading,"footer-props":{
      'disable-items-per-page': true,
      'items-per-page-options': []
    }},on:{"update:page":_vm.move},scopedSlots:_vm._u([{key:"item.packet",fn:function(ref){
    var item = ref.item;
return [_vm._v(" "+_vm._s(_vm.toHexString(item.packet.data))+" ")]}}])}),_c('v-divider')],1)}
var staticRenderFns = []

export { render, staticRenderFns }